import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  useTheme,
  FormHelperText,
  FormControl,
  OutlinedInput,
} from "@mui/material";
import AppButton from "../../base/AppButton.component";
import { boxChild, details, formControl } from "./Login.style";
import { InputValidation } from "../../../utils/InputValidationRegex";

const MfaOTPComponent = ({
  enteredOtp,
  mfaOptionLogin,
  loginError,
  wrongOtp,
  handleOTP,
  handleKeyPress,
}) => {
  let loginErrorEmpty = loginError;
  const theme = useTheme();
  const [helperText, setHelperText] = useState("");
  const [error, setError] = useState(false);
  const [otp, setOtp] = useState("");
  const handleOtpChange = (event) => {
    console.log("OTPLOG", event);
    const enteredValue = event.target.value;
    setOtp(enteredValue);
    enteredOtp(enteredValue);
  };
  const [login, setLogin] = useState(loginError);

  useEffect(() => {
    if (otp === "") {
      setHelperText("");
      setError(false);
    } else if (InputValidation.otpValidation(otp)) {
      setHelperText("Invalid OTP");
      setError(true);
      wrongOtp(false);
      // setHelperText("");
    } else if (login) {
      console.log("loginErrorEmpty", login);
      setHelperText("Wrong OTP. Please login again");
      setError(true);
      wrongOtp(true);
      let timeout = setTimeout(() => {
        setHelperText("");
        setError(false);
        setLogin(!login);
      }, 1000);
      return () => clearTimeout(timeout);
    } else {
      setHelperText("");
      setError(false);
    }
  }, [otp, login]);

  useEffect(() => {
    if (loginError) {
      console.log("loginError", login);
      setLogin(loginError);
    }
  }, [loginError, handleOTP]);
  const handleChange = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      console.log("Enter ", event);
      handleKeyPress({ key: "Enter" });
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Typography variant="span" component="div" sx={details(theme)}>
        Enter your security code
      </Typography>

      <FormControl sx={formControl} variant="outlined">
        <OutlinedInput
          onKeyDown={(e) => {
            handleChange(e);
          }}
          sx={{ width: "100%" }}
          variant="outlined"
          type="text"
          error={error}
          onChange={handleOtpChange}
        />
        <FormHelperText
          sx={{ color: helperText ? theme.palette.error.main : null }}
        >
          {helperText}
        </FormHelperText>
      </FormControl>

      <AppButton
        sx={{
          display: "flex",
          alignSelf: "flex-start",
        }}
        variant="text"
        color="primary"
        buttonText="Resend OTP"
        clickHandler={() => {
          mfaOptionLogin();
        }}
      />
    </Box>
  );
};

export default MfaOTPComponent;
